import React from "react";
import TeamPresenter from "./TeamPresenter";

const TeamContainer = () => {
  return <TeamPresenter />;
};

export default TeamContainer;
